import { Injectable, inject } from '@angular/core';
import { Project } from '../models/project.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class ProjectsService {
    private httpService = inject(HttpService);

    projects$ = new BehaviorSubject<Project[] | false>(false);
    private subscriptions = new Subscription();

    /**
     * Dispatch
     */
    dispatch(): void {
        this.subscriptions.add(
            this.httpService
                .getProjects()
                .pipe(tap((projects) => this.projects$.next(projects)))
                .subscribe(),
        );
    }

    /**
     * Destroy all pending subscritpions
     */
    destroy(): void {
        this.subscriptions.unsubscribe();
    }
}
